'use client';

import { useContext } from 'react';

import { DirectoryInteractionsContext } from '@/contexts/DirectoryInteractions';

import { Button } from '@/components/atoms/Button/Button';

interface GetMoreResultsButtonProps {
  buttonText?: string;
}

export const GetMoreResultsButton = ({
  buttonText = 'Get next results',
}: GetMoreResultsButtonProps) => {
  const { onGetMoreResults } = useContext(DirectoryInteractionsContext);

  return (
    <Button
      ariaLabel='get next results'
      iconRight='chevron-right'
      isRectangle={true}
      onClick={() => onGetMoreResults?.()}
    >
      {buttonText}
    </Button>
  );
};
